// import React from "react";
// import logo from "../assets/logo1.png"; // Use your provided logo file

// const Loading = () => (
//   <div className="min-h-screen flex items-center justify-center font-basefont bg-gradient-to-br from-pink-300 via-yellow-200 to-pink-100 overflow-hidden relative">
//     {/* Glowing ring ripple with multiple layers */}
//     <span className="absolute animate-ping w-56 h-56 rounded-full bg-pink-300/30 shadow-2xl z-0"></span>
//     <span className="absolute animate-pulse w-36 h-36 rounded-full bg-yellow-100/50 z-0"></span>
//     <span className="absolute w-72 h-72 bg-amber-100/60 rounded-full blur-2xl opacity-40 z-0 -top-28 -left-24"></span>
//     <span className="absolute w-80 h-80 bg-fuchsia-100/40 rounded-full blur-3xl opacity-40 z-0 -bottom-24 right-0"></span>

//     {/* Confetti sparkles */}
//     {[...Array(15)].map((_, i) => (
//       <span
//         key={i}
//         className="absolute rounded-full"
//         style={{
//           width: `${9 + Math.random() * 9}px`,
//           height: `${9 + Math.random() * 9}px`,
//           background: `radial-gradient(circle at 40% 60%, #ffb6d5, #ffd966 90%)`,
//           left: `${10 + Math.random() * 80}%`,
//           top: `${5 + Math.random() * 85}%`,
//           opacity: `${0.35 + Math.random() * 0.45}`,
//           filter: `blur(${Math.random() > 0.7 ? 1 : 0}px)`
//         }}
//       />
//     ))}

//     {/* Logo splashing in */}
//     <div className="relative flex flex-col items-center z-10">
//       <img
//         src={logo}
//         alt="Loading Logo"
//         className="w-28 h-28 object-contain drop-shadow-lg animate-[splashEffect_1.1s_ease-in-out]"
//         style={{
//           animation: "splashEffect 1.1s cubic-bezier(.23,1.08,.16,1.01) infinite alternate"
//         }}
//       />
//       {/* Animated Gradient Text */}
//       <h1
//         className="mt-9 text-3xl font-extrabold bg-gradient-to-r from-pink-600 via-yellow-500 to-pink-400 bg-clip-text text-transparent drop-shadow-xl
//         animate-gradient-x tracking-tight select-none"
//         style={{ fontFamily: "inherit" }}
//       >
//         Loading...
//       </h1>
//     </div>

//     {/* Splash effect and animated gradient keyframes */}
//     <style>{`
//       @keyframes splashEffect {
//         0% {
//           transform: scale(0.15) rotate(-18deg);
//           opacity: 0;
//         }
//         70% {
//           transform: scale(1.12) rotate(8deg);
//           opacity: 1;
//         }
//         80% {
//           transform: scale(1.04) rotate(-5deg);
//         }
//         100% {
//           transform: scale(1) rotate(0deg);
//           opacity: 1;
//         }
//       }
//       .animate-gradient-x {
//         background-size: 200% 200%;
//         animation: gradientMove 2.4s linear infinite alternate;
//       }
//       @keyframes gradientMove {
//         0% { background-position: 0% 50%; }
//         100% { background-position: 100% 50%; }
//       }
//     `}
//     </style>
//   </div>
// );

// export default Loading;
// import React, { useEffect, useState } from "react";

// const Loading = () => {
//   const word = "VIESHARAA";
//   const [displayedLetters, setDisplayedLetters] = useState([]);

//   useEffect(() => {
//     let idx = 0;
//     const interval = setInterval(() => {
//       setDisplayedLetters((prev) => [...prev, word[idx]]);
//       idx++;
//       if (idx === word.length) clearInterval(interval);
//     }, 250);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="min-h-screen relative flex items-center justify-center font-serif bg-[#FFFBF0] overflow-hidden">
//       {/* Animated/BG Blobs */}
//       <span className="absolute w-80 h-80 bg-pink-200/30 rounded-full blur-3xl left-[-6rem] top-[-6rem] animate-blob1"></span>
//       <span className="absolute w-72 h-72 bg-yellow-100/40 rounded-full blur-3xl right-[-5rem] bottom-[-8rem] animate-blob2"></span>
//       <span className="absolute w-60 h-60 bg-rose-100/40 rounded-full blur-2xl left-[55%] top-[70%] animate-blob3"></span>

//       {/* Typing letters */}
//       <div className="flex space-x-6 select-none z-10">
//         {word.split("").map((letter, i) => (
//           <span
//             key={i}
//             className={`text-2xl sm:text-5xl font-black tracking-widest text-[#ae001d]
//               opacity-0 transform scale-50
//               ${
//                 displayedLetters.includes(letter) || displayedLetters.length > i
//                   ? "animate-appear"
//                   : ""
//               }
//             `}
//             style={{ animationDelay: `${i * 250}ms` }}
//           >
//             {letter}
//           </span>
//         ))}
//       </div>

//       {/* Keyframes for letters and animated blobs */}
//       <style>{`
//         @keyframes appear {
//           0% {
//             opacity: 0;
//             transform: scale(0.5);
//           }
//           60% {
//             opacity: 1;
//             transform: scale(1.15);
//           }
//           100% {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }
//         .animate-appear {
//           animation: appear 600ms ease forwards;
//         }

//         @keyframes blob1 {
//           0%, 100% { transform: scale(1) translateY(0); }
//           50% { transform: scale(1.1) translateY(-24px); }
//         }
//         @keyframes blob2 {
//           0%, 100% { transform: scale(1) translateY(0) translateX(0); }
//           50% { transform: scale(1.15) translateY(30px) translateX(-15px); }
//         }
//         @keyframes blob3 {
//           0%, 100% { transform: scale(1) translateX(0) }
//           50% { transform: scale(1.12) translateX(-10px) }
//         }
//         .animate-blob1 { animation: blob1 7s ease-in-out infinite; }
//         .animate-blob2 { animation: blob2 8.5s ease-in-out infinite; }
//         .animate-blob3 { animation: blob3 10s ease-in-out infinite; }
//       `}</style>
//     </div>
//   );
// };

// export default Loading;


// import React, { useEffect, useState } from "react";
// import logo from "../assets/logo1.png"; // Replace with your actual logo path

// const Loading = () => {
//   const [showLogo, setShowLogo] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowLogo(true);
//     }, 250); // Delay before showing logo (optional)

//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <div className="min-h-screen relative flex items-center justify-center font-serif bg-[#FFEDD7] overflow-hidden">
//       {/* Animated BG Blobs */}
//       <span className="absolute w-80 h-80 bg-pink-200/30 rounded-full blur-3xl left-[-6rem] top-[-6rem] animate-blob1"></span>
//       <span className="absolute w-72 h-72 bg-yellow-100/40 rounded-full blur-3xl right-[-5rem] bottom-[-8rem] animate-blob2"></span>
//       <span className="absolute w-60 h-60 bg-rose-100/40 rounded-full blur-2xl left-[55%] top-[70%] animate-blob3"></span>

//       {/* Logo with animation */}
//     {showLogo && (
//   <div className="flex flex-col items-center justify-center text-center z-10 space-y-3">
//    <img
//   src={logo}
//   alt="Logo"
//   className="w-48 h-auto sm:w-60 animate-logo-blink"
// />

//     <p className="inline-block bg-[#ae001d]/10 text-[#ae001d] italic px-4 py-2 rounded-md shadow-sm text-md font-light tracking-wide sm:tracking-widest">
//       Crafting Elegance
//     </p>
//   </div>
// )}


//       {/* Keyframes for animations */}
//       <style>{`
//         @keyframes logo-blink {
//           0% { opacity: 0; transform: scale(0.5); }
//           60% { opacity: 1; transform: scale(1.1); }
//           100% { opacity: 1; transform: scale(1); }
//         }

//         .animate-logo-blink {
//           animation: logo-blink 800ms ease forwards;
//         }

//         @keyframes blob1 {
//           0%, 100% { transform: scale(1) translateY(0); }
//           50% { transform: scale(1.1) translateY(-24px); }
//         }
//         @keyframes blob2 {
//           0%, 100% { transform: scale(1) translateY(0) translateX(0); }
//           50% { transform: scale(1.15) translateY(30px) translateX(-15px); }
//         }
//         @keyframes blob3 {
//           0%, 100% { transform: scale(1) translateX(0) }
//           50% { transform: scale(1.12) translateX(-10px) }
//         }
//         .animate-blob1 { animation: blob1 7s ease-in-out infinite; }
//         .animate-blob2 { animation: blob2 8.5s ease-in-out infinite; }
//         .animate-blob3 { animation: blob3 10s ease-in-out infinite; }
//       `}</style>
//     </div>
//   );
// };

// export default Loading;


import React, { useEffect, useState } from "react";
import logo from "../assets/nl/newLogoWidName.jpg"; // Update with your real logo path

const Loading = () => {
  const [showLogo, setShowLogo] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowLogo(true), 250);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen relative flex items-center justify-center font-serif bg-[#fff] overflow-hidden">
      {/* Animated Blobs */}
      <span className="absolute w-80 h-80 bg-pink-200/30 rounded-full blur-3xl left-[-6rem] top-[-6rem] animate-blob1"></span>
      <span className="absolute w-72 h-72 bg-yellow-100/40 rounded-full blur-3xl right-[-5rem] bottom-[-8rem] animate-blob2"></span>
      <span className="absolute w-60 h-60 bg-rose-100/40 rounded-full blur-2xl left-[55%] top-[70%] animate-blob3"></span>

      {/* Animated Logo and Text */}
      {showLogo && (
        <div className="flex flex-col items-center justify-center text-center z-10 space-y-4">
          <img
            src={logo}
            alt="Logo"
            className="w-48 h-auto sm:w-60 animate-logo-blink"
          />
          <p className="inline-block bg-[#c5a558]/10  text-[#000] italic px-4 py-2 rounded-md shadow-sm text-md font-light tracking-wide sm:tracking-widest">
            Crafting Elegance
          </p>
          {/* Progress Bar */}
          <div className="mt-10 w-56 h-2 rounded-full bg-[#c5a558]/10 overflow-hidden relative">
            <div className="absolute left-0 top-0 h-full bg-gradient-to-r from-[#c5a558] via-yellow-400 to-pink-400 animate-loading-bar" />
          </div>
        </div>
      )}

      {/* Animations and progress bar keyframes */}
      <style>{`
        @keyframes logo-blink {
          0% { opacity: 0; transform: scale(0.5); }
          60% { opacity: 1; transform: scale(1.1); }
          100% { opacity: 1; transform: scale(1); }
        }
        .animate-logo-blink {
          animation: logo-blink 800ms ease forwards;
        }
        @keyframes blob1 {
          0%, 100% { transform: scale(1) translateY(0); }
          50% { transform: scale(1.1) translateY(-24px); }
        }
        @keyframes blob2 {
          0%, 100% { transform: scale(1) translateY(0) translateX(0); }
          50% { transform: scale(1.15) translateY(30px) translateX(-15px); }
        }
        @keyframes blob3 {
          0%, 100% { transform: scale(1) translateX(0) }
          50% { transform: scale(1.12) translateX(-10px) }
        }
        .animate-blob1 { animation: blob1 7s ease-in-out infinite; }
        .animate-blob2 { animation: blob2 8.5s ease-in-out infinite; }
        .animate-blob3 { animation: blob3 10s ease-in-out infinite; }

        @keyframes loading-bar {
          0% { width: 0%; }
          100% { width: 100%; }
        }
        .animate-loading-bar {
          animation: loading-bar 2.2s cubic-bezier(0.72,0,0.44,1.01) forwards;
        }
      `}</style>
    </div>
  );
};

export default Loading;
